import React from 'react';
import Text from '../Text';
import Button from '../Button';

function LoginPromotionBanner({ loginPromotionHandler }) {
  return (
    <div className="bg-cart-login-bar px-12 py-8 rounded-xl w-full">
      <div className="flex items-center justify-between flex-row gap-x-4">
        <Text
          type="paragraph"
          className="text-12 text-white font-encode-sans font-semibold leading-16 tracking-[0.24px]"
        >
          Log in and enjoy a personalized experience and greater savings!
        </Text>
        <Button
          type="outline"
          className="min-w-[80px] border-white !px-16 !py-10 rounded-[100px] hover:bg-white/15"
          onClick={() => {
            loginPromotionHandler();
          }}
        >
          <Text
            type="paragraph"
            className="text-14 text-white font-encode-sans font-bold leading-20 tracking-[0.28px]"
          >
            Log In
          </Text>
        </Button>
      </div>
    </div>
  );
}

export default LoginPromotionBanner;
